(function() { window.GUID_7799ec1b_b864_40ef_9162_829aa315f6e6 = { getGuid: function() { return "7799ec1b-b864-40ef-9162-829aa315f6e6"; } }; })();
var CS;
(function (CS) {
    var Views;
    (function (Views) {
        var Account;
        (function (Account) {
            class EmailSubscription extends Views.ViewBase {
                OnDispose() {
                }
                constructor() {
                    super();
                    var checkboxChanged = CS.Controls.CheckBox.Events.CheckboxValueChanged;
                    checkboxChanged({
                        selector: "#checkbox-selectall",
                        callback: (ctrl, e) => {
                            let checkboxes = $('.checkbox:not(#checkbox-selectall)');
                            checkboxes.each(function () {
                                CS.Controls.GetInstance(CS.Controls.CheckBox, $(this)).SetValue(ctrl.GetValue() == 'true');
                            });
                        }
                    });
                    checkboxChanged({
                        selector: CS.DOM.$sectionMaster,
                        childSelector: ".checkbox:not(#checkbox-selectall)",
                        callback: (ctrl, e) => {
                            let $checkboxes = $('.checkbox:not(#checkbox-selectall)');
                            let $checkboxAll = $('#checkbox-selectall');
                            let checkboxAll = CS.Controls.GetInstance(CS.Controls.CheckBox, $checkboxAll);
                            let valueOr = ctrl.GetValue() == "true";
                            let valueAnd = ctrl.GetValue() == "true";
                            $checkboxes.each(function () {
                                let currentValue = CS.Controls.GetInstance(CS.Controls.CheckBox, $(this)).GetValue() == "true";
                                valueOr = valueOr || currentValue;
                                valueAnd = valueAnd && currentValue;
                            });
                            if (valueAnd == valueOr) {
                                checkboxAll.SetValue(valueAnd);
                            }
                            else {
                                checkboxAll.SetValue(null);
                            }
                        }
                    });
                }
            }
            Views.PageContext.OnPageLoaded({ actionName: "emailsubscription", controllerName: "emailsubscriptionfromemail" }, () => new EmailSubscription());
        })(Account = Views.Account || (Views.Account = {}));
    })(Views = CS.Views || (CS.Views = {}));
})(CS || (CS = {}));

//# sourceMappingURL=account.email-subscription.js.map
